// Redux

import ngRedux from 'ng-redux';
import { combineReducers } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';

import {
  initial_state,
  rootReducer
} from './store.rootReducer';

const loggingMiddleware = createLogger({
  level: 'info',
  collapsed: true,
  duration: true,
  diff: true
});


let storeEnhancers = [];
if (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__) {
  storeEnhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
}

export default angular
  .module('app-store', [ngRedux])

  .config(($ngReduxProvider) => {
    '@ngInject';

    /**
     API ngRedux.createStoreWith
     @see https://github.com/angular-redux/ng-redux#createstorewithreducer-middlewares-storeenhancers-initialstate

     > createStoreWith(reducer, [middlewares], [storeEnhancers], [initialState])

     Creates the Redux store, and allow connect() to access it.

     Arguments:

     reducer (Function): A single reducer composed of all other reducers (create with redux.combineReducer)
     [middlewares] (Function[]): Optional, An array containing all the middleware that should be applied. Functions and strings are both valid members. String will be resolved via Angular, allowing you to use dependency injection in your middlewares.
     [storeEnhancers] (Function[]): Optional, this will be used to create the store, in most cases you don't need to pass anything, see Store Enhancer official documentation.
     [initialState] (Object): Optional, the initial state of your Redux store.
     */
    $ngReduxProvider.createStoreWith(
      rootReducer,
      [thunk, loggingMiddleware],
      storeEnhancers,
      initial_state
    );
  })

  .run(($ngRedux, $rootScope, $timeout) => {
    'ngInject';

    // TODO  rendere parametrico per la build finale (query param)

    //To reflect state changes when disabling/enabling actions via the monitor
    //there is probably a smarter way to achieve that
    // @see https://github.com/angular-redux/ng-redux
    $ngRedux.subscribe(() => {
      $timeout(() => {$rootScope.$apply(() => {})}, 10);
    });
  })

  .name;




// WEBPACK FOOTER //
// ./client/app/store.config.js